import React from 'react';
import { Input } from './ui/input';

/**
 * Brazilian-formatted number input (thousands separator, no decimals).
 * Internally stores integer. Displays "44.888".
 */
export default function NumberInput({ value, onChange, placeholder, ...rest }) {
  const display =
    value === '' || value === null || value === undefined
      ? ''
      : Number(value).toLocaleString('pt-BR');

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '');
    if (!digits) {
      onChange('');
      return;
    }
    onChange(parseInt(digits, 10));
  };

  const handleKeyDown = (e) => {
    if (
      e.key === 'Backspace' ||
      e.key === 'Delete' ||
      e.key === 'Tab' ||
      e.key === 'Enter' ||
      e.key.startsWith('Arrow') ||
      e.ctrlKey || e.metaKey
    ) return;
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Input
      type="text"
      inputMode="numeric"
      autoComplete="off"
      className="text-right tabular"
      value={display}
      placeholder={placeholder || '0'}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      {...rest}
    />
  );
}
